import { render, staticRenderFns } from "./ConclusionResult.vue?vue&type=template&id=469f550c&"
import script from "./ConclusionResult.vue?vue&type=script&lang=js&"
export * from "./ConclusionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports